import type { FastifyRequest, FastifyReply } from 'fastify'
import type { ZodSchema } from 'zod'

export function validateRequest(schema: ZodSchema) {
  return (request: FastifyRequest, reply: FastifyReply, done: (err?: Error) => void): void => {
    const result = schema.safeParse(request.body)

    if (!result.success) {
      request.log.warn(result.error, 'Validation error')
      reply.code(400).send({
        message: 'Validation failed',
        errors: result.error
      })
      return
    }

    request.body = result.data as typeof request.body
    done()
  }
}
